import React from 'react'
import { NavigationLevel, NavigationUtility } from '../../Utilities/NavigationUtility'
import './Navbar.css'

const Navbar = () => {

    return (
        <div className="navbar-container px-0 sticky-top">
            <div className="container">
                <nav className="navbar navbar-expand-sm navbar-dark bg-dark py-0">
                    <button className="navbar-toggler mx-2 my-1 border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
                        <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
                            <li className="nav-item">
                                <a className="nav-link py-0" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" href="javascript:void(0)" onClick={() => NavigationUtility.navigateTo(NavigationLevel.Home)}>Home</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link py-0" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" href="javascript:void(0)" onClick={() => NavigationUtility.navigateTo(NavigationLevel.Portfolio)}>Portfolio</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link py-0" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" href="javascript:void(0)" onClick={() => NavigationUtility.navigateTo(NavigationLevel.Resume)}>Resume</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link py-0" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" href="javascript:void(0)" onClick={() => NavigationUtility.navigateTo(NavigationLevel.Contact)}>Contact</a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    )
}

export default Navbar
